import React from 'react';

import { flagStyles } from '../settings';

const SvgAO = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-168px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgAO;
